import React, { useState } from "react";
import { Map } from "immutable";
import T from "prop-types";
import { ToggleSwitch } from "MODULES/shared/containers";
import {
  Modal,
  Header,
  Close,
  Body,
  Footer
} from "MODULES/shared/components/Modal";
import { DropDownItem, Icon } from "MODULES/shared/components";
import { Button, Col } from "react-bootstrap";
import DownloadUrl from "MODULES/SalesOrders/components/Detail/Actions/DownloadProForma/DownloadUrl";
import { truncate } from "LIB/formatters/text";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import withSalesOrder from "../../../../decorators/withSalesOrder";

function DownloadProForma({ salesOrder }) {
  const [processingFee, setProcessingFee] = useState(0);
  const [chargeType, setChargeType] = useState(null);
  const [chargeValue, setChargeValue] = useState(null);
  const [note, setNote] = useState(null);

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open}>
          <Icon name="dollar" fixed />
          &nbsp;Download Pro Forma
          <Modal open={visible} close={close} dialogClass="modal-sm">
            <Header>
              <Close close={close} />
              <h4 className="modal-title">Download Pro Forma</h4>
            </Header>
            <Body>
              <h3 style={{ textAlign: "center" }}>Include processing fee?</h3>
              <div style={{ width: "33%", margin: "0 auto" }}>
                <label htmlFor="processing-fee">optional</label>
                <div className="form-group">
                  <div className="input-group">
                    <span className="input-group-addon">
                      <i className="fa fa-dollar" />
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      value={processingFee}
                      onChange={ev => setProcessingFee(ev.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3 style={{ textAlign: "center" }}>
                Include Additional Charges?
              </h3>
              <div style={{ width: "100%", margin: "0 auto" }}>
                <FormRow>
                  <Col md={6}>
                    <label htmlFor="charge-type">Charge Type</label>
                    <div className="form-group">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          value={chargeType}
                          onChange={ev => setChargeType(ev.target.value)}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <label htmlFor="charge-value">Charge Value</label>
                    <div className="form-group">
                      <div className="input-group">
                        <span className="input-group-addon">
                          <i className="fa fa-dollar" />
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          value={chargeValue}
                          onChange={ev => setChargeValue(ev.target.value)}
                        />
                      </div>
                    </div>
                  </Col>
                </FormRow>
              </div>
              <h3 style={{ textAlign: "center" }}>Add note?</h3>
              <div style={{ width: "70%", margin: "0 auto" }}>
                <label htmlFor="note">optional</label>
                <div className="form-group">
                  <div className="input-group">
                    <textarea
                      className="form-control"
                      rows={3}
                      cols={50}
                      value={note}
                      onChange={ev =>
                        setNote(truncate(ev.target.value, 100, ""))}
                    />
                  </div>
                </div>
              </div>
            </Body>
            <Footer>
              <Button onClick={close}>Cancel</Button>
              <DownloadUrl
                close={close}
                chargeType={chargeType}
                chargeValue={chargeValue}
                salesOrder={salesOrder}
                note={note}
                processingFee={processingFee}
              />
            </Footer>
          </Modal>
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

export default withSalesOrder(DownloadProForma);

DownloadProForma.propTypes = {
  salesOrder: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/DownloadProForma/DownloadProForma.jsx